import { useState } from 'react'

export const useCopyToClipboard = (resetAfterMs = 2000) => {
    const [copied, setCopied] = useState(false)

    const copy = async (value: string) => {
        try {
            await navigator.clipboard.writeText(value)
            setCopied(true)
            window.setTimeout(() => setCopied(false), resetAfterMs)
        } catch {
            setCopied(false)
        }
    }

    return { copied, copy }
}
